import { render, staticRenderFns } from "./NewInstantBookings.vue?vue&type=template&id=08d18f33&"
import script from "./NewInstantBookings.vue?vue&type=script&lang=js&"
export * from "./NewInstantBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d18f33')) {
      api.createRecord('08d18f33', component.options)
    } else {
      api.reload('08d18f33', component.options)
    }
    module.hot.accept("./NewInstantBookings.vue?vue&type=template&id=08d18f33&", function () {
      api.rerender('08d18f33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/NewInstantBookings.vue"
export default component.exports